import { render, staticRenderFns } from "./blogcategorydetails.vue?vue&type=template&id=0f0e4139&scoped=true&"
import script from "./blogcategorydetails.vue?vue&type=script&lang=js&"
export * from "./blogcategorydetails.vue?vue&type=script&lang=js&"
import style0 from "./blogcategorydetails.vue?vue&type=style&index=0&id=0f0e4139&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0e4139",
  null
  
)

export default component.exports